export default "__VITE_ASSET__BswgZq2a__"